import React from 'react';
import { StatusBar } from 'react-native';

import R from 'common/res/R';

const DefaultStatusBar = () => (
  <StatusBar backgroundColor={R.color.brand} barStyle="light-content" />
);

export default DefaultStatusBar;
